module.exports = __webpack_public_path__ + "static/media/onboardingPayway.db06de5c.svg";